export default __webpack_public_path__ + "static/media/slack-logo.08a9dcfe.png";